import { render, staticRenderFns } from "./form-history-version.vue?vue&type=template&id=104e318c&scoped=true&"
import script from "./form-history-version.vue?vue&type=script&lang=js&"
export * from "./form-history-version.vue?vue&type=script&lang=js&"
import style0 from "./form-history-version.vue?vue&type=style&index=0&id=104e318c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104e318c",
  null
  
)

component.options.__file = "form-history-version.vue"
export default component.exports